import { useEffect, useRef } from "react";

export function useDebounce(
  value: string,
  originalValue: string,
  timeout: number,
  onChange: () => unknown,
): void {
  const timeoutRef = useRef<number>();

  useEffect(() => {
    if (value !== originalValue) {
      window.clearTimeout(timeoutRef.current);

      timeoutRef.current = window.setTimeout(onChange, timeout);
    }

    return () => {
      window.clearTimeout(timeoutRef.current);
    };
  }, [value]);
}
